import { todayIso } from "./rolloFormat";

// saveBlob moved to the shared folder; re-exported so Rollo keeps importing it from here.
export { saveBlob } from "../crmpostventa-shared/saveBlob";

// Same name as the server's Content-Disposition, for when the header is missing.
export const fallbackExportName = (now = new Date()) => `Rollo_Finalizadas_${todayIso(now).replace(/-/g, "")}.xlsx`;

// Warning for a file the server cut at its row limit: rows written (X-Rollo-Export-Rows) of the matching total.
// The client does not know the limit, so without the rows it says only that part of them went out.
export const truncationMessage = ({ rows, total }) =>
  rows === null || rows === undefined
    ? `Se exportó una parte de las ${total} gestiones. Ajustá los filtros para exportar el resto.`
    : `Se exportaron las primeras ${rows} de ${total} gestiones. Ajustá los filtros para exportar el resto.`;
